import React, { Component, createRef } from 'react';
import { Modal, Fade, Button, TextField, Grid } from '@mui/material';
import { AddBox, TapAndPlay } from '@mui/icons-material';
import { translate } from '../../i18n/customI18nProvider';
import Swal from 'sweetalert2';
import config from '../../config';
import { createNewPacket, generateQrsFile } from '../../services/wristbandCategory.service';
import UidReader from '../nfc/UidReader';

const styles = {
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: 'whitesmoke',
    borderRadius: '10px',
    padding: '20px',
    minWidth: '40vw'
  },
};

class WristbandManualReconditioning extends Component {

    constructor(props) {
        super(props);
        this.uidReaderRef = createRef();
        this.onSuccess = props.onSuccess || null;
        this.state = {
            open: false,
            packet_size: 100,
            wristbands: [],
            category_id: null
        }
    }

    componentDidMount() {
        this.setState({category_id: this.props.category_id});
        window.addEventListener("beforeunload", this.beforeUnloadHandler);
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    }

    beforeUnloadHandler = (e) => {
        if (this.state.wristbands.length > 0) {
            e.preventDefault();
            e.returnValue = ""; 
        }
    };

    handleWristbandsChange = async (currentWristbands) => {
        this.setState({ wristbands: currentWristbands });
        if(currentWristbands.length >= this.state.packet_size) {
            await Swal.fire({
                icon: 'info',
                title: translate('custom.packet_full'),
                confirmButtonColor: config.baseColor
            });
            this.createPacket();
        }
    }

    handleOpen = () => {
        this.setState({open: true});
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    createPacket = async () => {
        const { wristbands, packet_size, category_id } = this.state;

        if(wristbands.length === 0) {
            Swal.fire({
                icon: 'error',
                title: translate('custom.error'),
                text: translate('custom.no_wristbands_to_create_packet'),
                confirmButtonColor: config.baseColor
            });
            return;
        }

        if(wristbands.length < packet_size) {
            const confirm = await Swal.fire({
                icon: 'question',
                title: translate('custom.confirm_create_new_packet'),
                text: translate('custom.are_you_sure_you_want_to_create_new_packet'),
                showCancelButton: true,
                confirmButtonText: translate('custom.yes'),
                cancelButtonText: translate('custom.cancel'),
                confirmButtonColor: config.baseColor
            });
            if(!confirm.isConfirmed) return;
        }

        const response = await createNewPacket(category_id, wristbands.map(w => w.uid));
        
        if(response.error) {
            Swal.fire({
                icon: 'error',
                title: translate('custom.error'),
                text: response.error,
                confirmButtonColor: config.baseColor
            });
            return;
        }

        Swal.fire({
            icon: 'success',
            title: translate('custom.packet_created_successfully'),
            text: translate('custom.short_id') + ": " + response.packet.shortId,
            confirmButtonColor: config.baseColor
        })

        const file = await generateQrsFile(response.category_name, [response.packet]);
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        if(this.onSuccess) {
            this.onSuccess();
        }

        if (this.uidReaderRef.current) {
            this.uidReaderRef.current.resetList();
        }
    }

    render() {
        return (
            <div>                
                <Button 
                    variant="contained"
                    color="primary"
                    onClick={this.handleOpen}
                    startIcon={<TapAndPlay />}
                >
                    {translate('custom.manual_reconditioning')}
                </Button>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    style={styles.modal}
                    open={this.state.open}
                    onClose={this.handleClose}
                    closeAfterTransition
                >
                    <Fade in={this.state.open}>
                        <div style={styles.paper}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField 
                                        style={{width: '100%'}} 
                                        type="number" 
                                        label={translate('custom.packet_size')} 
                                        value={this.state.packet_size} 
                                        onChange={(e) => this.setState({packet_size: e.target.value})} 
                                    />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <UidReader 
                                        ref={this.uidReaderRef}
                                        onMounted={() => {
                                            this.uidReaderRef?.current?.setBaseWristbands(this.state.wristbands);
                                        }}
                                        onWristbandsChange={this.handleWristbandsChange}
                                    />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Button 
                                        startIcon={<AddBox />} 
                                        variant="contained" 
                                        color="primary" 
                                        style={{width: '100%'}} 
                                        onClick={this.createPacket}
                                        disabled={this.state.wristbands.length === 0}
                                    >
                                        {translate('custom.create_new_packet')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }
}

export default WristbandManualReconditioning;